import React from "react";
import "./backnext.css";
import backButtons from "../../../../../assets/icons/backButtons.svg";
import { Button, Col, Row } from "antd";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { LoadingOutlined } from "@ant-design/icons";
import { useWindowDimensions } from "../../../../../hooks/useDimensionHook";
const CandidateSignupButton = ({
  backFunction,
  nextFunction,
  nextBtnLoading,
  skipFunction,
  text = "Next",
  isOptional=true,
}) => {
  const { pathname } = useLocation();
  const { width } = useWindowDimensions();
  
  return (
    <div className="BottomButtonsParentContainer">
      <div className="buttonsContainer">
        <Row className="Btns-row2">
          <div className="gap-back-next-signup-buttons">
            {width > 768 && (
              <Col lg={11} xs={24} md={10} className={"Back-btn-div"}>
                <Button className="Back-btn" onClick={backFunction}>
                  Back
                </Button>
              </Col>
            )}
            {width > 768 && (
              <Col lg={11} xs={24} md={10} className="Next-btn-div">
                <Button
                  className="Next-btn"
                  onClick={nextFunction}
                  type="submit"
                  disabled={nextBtnLoading}
                  // loading={nextBtnLoading}
                >
                  <span className="btn-read-rules1">
                    {nextBtnLoading ? <LoadingOutlined /> : text}
                  </span>
                </Button>
              </Col>
            )}
            {isOptional &&
            width > 768 &&
            pathname != "/resume-upload-v2" ? (
              <Col lg={11} xs={24} md={10} className={"Next-btn-div"}>
                <Button className="Skip-btn" onClick={skipFunction}>
                  Skip
                </Button>
              </Col>
            ) : (
              ""
            )}
          </div>

          {width <= 768 ? (
            <div className="main-div-mobile1">
              <div className="button-mob-view1">
                <button onClick={backFunction} className="back-btn-mobile1">
                  <img src={backButtons} />
                </button>

                {isOptional ? (
                  <button className="skip-btn-mobile1" onClick={skipFunction}>
                    Skip
                  </button>
                ) : null}

                <button onClick={nextFunction} className="next-btn-mobile1" type="submit" disabled={nextBtnLoading}>
                  <span className="btn-read-rules1">
                    {nextBtnLoading ? <LoadingOutlined /> : text}
                  </span>
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
        </Row>
      </div>
    </div>
  );
};

export default CandidateSignupButton;
